var _circle, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 21.5,
    r: 21.5,
    fill: "#E6E6E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.6849 16.8083C27.5956 16.6327 27.413 16.5217 27.2133 16.5217H24.0939C23.8027 16.5217 23.5666 16.7538 23.5666 17.0401C23.5666 17.3263 23.8027 17.5584 24.0939 17.5584H26.8874L28.6194 20.9633H13.3806L15.1126 17.5584H17.9061C18.1973 17.5584 18.4334 17.3263 18.4334 17.0401C18.4334 16.7538 18.1973 16.5217 17.9061 16.5217H14.7867C14.587 16.5217 14.4044 16.6327 14.3151 16.8083L12.0557 21.2498C11.9739 21.4105 11.9827 21.6013 12.0788 21.7542C12.1748 21.907 12.3446 22 12.5273 22H29.4727C29.6554 22 29.8252 21.907 29.9212 21.7542C30.0173 21.6013 30.0261 21.4105 29.9443 21.2498L27.6849 16.8083Z",
    fill: "#033476"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.3043 19.0652C25.3043 18.7411 25.0775 18.4783 24.7978 18.4783H17.2022C16.9224 18.4783 16.6956 18.7411 16.6956 19.0652C16.6956 19.3894 16.9224 19.6522 17.2022 19.6522H24.7978C25.0775 19.6522 25.3043 19.3894 25.3043 19.0652Z",
    fill: "#033476"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 21.3577C30 21.0641 29.7639 20.8261 29.4727 20.8261H12.5273C12.2361 20.8261 12 21.0641 12 21.3577V30.4684C12 30.762 12.2361 31 12.5273 31H29.4727C29.7639 31 30 30.762 30 30.4684V21.3577ZM28.9453 21.8893V29.9368H13.0547V21.8893H28.9453Z",
    fill: "#033476"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.2609 24.1225C27.2609 23.8147 27.0216 23.5652 26.7263 23.5652H15.2738C14.9785 23.5652 14.7392 23.8147 14.7392 24.1225V27.7036C14.7392 28.0114 14.9785 28.2609 15.2738 28.2609H26.7263C27.0216 28.2609 27.2609 28.0114 27.2609 27.7036V24.1225ZM26.1917 24.6797V27.1464H15.8084V24.6797H26.1917Z",
    fill: "#033476"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 14.0467C22.3794 14.0467 23.4996 15.1938 23.4996 16.6064C23.4996 17.4139 23.1338 18.1353 22.5604 18.6055H19.4396C18.8662 18.1353 18.5004 17.4139 18.5004 16.6064C18.5004 15.1938 19.6206 14.0467 21 14.0467ZM24.5217 16.6064C24.5217 14.6158 22.9438 13 21 13C19.0561 13 17.4783 14.6158 17.4783 16.6064C17.4783 17.8261 18.0712 18.9047 18.9751 19.5567C19.0612 19.6188 19.164 19.6522 19.2694 19.6522H22.7306C22.836 19.6522 22.9387 19.6188 23.0249 19.5567C23.9287 18.9047 24.5217 17.8261 24.5217 16.6064Z",
    fill: "#033476"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon7);
export default __webpack_public_path__ + "static/media/icon7.0873dcb68d8dcb864932cbe2c4f8f57d.svg";
export { ForwardRef as ReactComponent };